import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Button, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popconfirm } from "antd";

import { closeCustomModal, openCustomModal } from "components/custom/modals";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";

import {
    fetchConsumerGroups,
    deleteConsumerGroup,
    clearConsumerGroups
} from "api/menu/master-files/consumer-groups/actions";

// import ConsumerGroupsModal from "components/menu/master-files/consumer-groups/edit-modal";
const ConsumerGroupsModal = React.lazy(() =>
    import("components/menu/master-files/consumer-groups/edit-modal"));

class ConsumerGroups extends React.Component {
    constructor(props) {
        super(props);

        this.modalOpen = this.modalOpen.bind(this);
    }

    componentDidMount () {
        this.props.fetchConsumerGroups();
    }

    componentWillUnmount () {
        this.props.clearConsumerGroups();
    }

    delete = (id, code) => {
        const callback = () => {
            this.props.fetchConsumerGroups();
        };
        this.props.deleteConsumerGroup(id, code, callback);
    };

    modalOpen = (id = false) => {
        const modalTitle = id !== false ? "Update" : "Create";

        const modalObj = {
            id: `consumer-group-item-${id}`,
            header: `${modalTitle} Consumer Group`,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ConsumerGroupsModal
                        id={id}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render () {
        const {
            consumerGroups,
            loading
        } = this.props;

        const classNameFlexCenter = "d-flex justify-content-center align-items-center";
        const columns = [
            {
                Header: "Code",
                accessor: "code",
                id: "code",
            },
            {
                Header: "Description",
                accessor: "description",
                id: "description",
            },
            {
                Header: "Active?",
                id: "isInactive",
                accessor: original => (original.isInactive ? "NO" : "YES"),
                Cell: ({ original }) => (original.isInactive ? "NO" : "YES"),
                className: classNameFlexCenter,
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Active",
                            NO: "Inactive"
                        }}
                    />
                )
            },
            {
                Header: "Actions",
                id: "actions",
                className: classNameFlexCenter,
                Cell: ({ original }) => (
                    <ButtonGroup>
                        <Button size="sm" onClick={() => this.modalOpen(original.id)}>
                            <FontAwesomeIcon icon="pen" title="Update" />
                        </Button>
                        <Popconfirm
                            title={`Delete "${original.code}"?`}
                            onConfirm={() => this.delete(original.id, original.code)}
                            placement="bottomRight"
                            okText="Yes"
                            cancelText="Cancel"
                        >
                            <Button variant="danger" size="sm">
                                <FontAwesomeIcon icon="times" />
                            </Button>
                        </Popconfirm>
                    </ButtonGroup>
                ),
                filterable: false,
                width: 100
            }
        ];

        return (
            <div className="dashboard">
                <h3 className="mb-4">Consumer Groups</h3>

                <ReactTable
                    data={consumerGroups}
                    headerClassName="table-header"
                    columns={columns}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100]}
                    resizable
                    className="-striped -highlight"
                    loading={loading}
                    filterable
                    defaultFilterMethod={filterCaseInsensitive}
                    defaultSorted={[
                        {
                            id: "code",
                            desc: false
                        }
                    ]}
                    defaultFiltered={[
                        {
                            id: "isInactive",
                            value: "YES"
                        }
                    ]}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                    style={{
                        height: "calc(100vh - 200px)",
                    }}
                />

                <div className="mt-4 mb-4 text-right">
                    <Button className="ml-2" variant="primary" onClick={() => this.modalOpen()}>
                        Add New Consumer Group
                    </Button>
                </div>
            </div>
        );
    }
}

ConsumerGroups.propTypes = {
    fetchConsumerGroups: PropTypes.func.isRequired,
    deleteConsumerGroup: PropTypes.func.isRequired,
    clearConsumerGroups: PropTypes.func.isRequired,
    consumerGroups: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    consumerGroups: state.consumerGroups.consumerGroups,
    loading: state.consumerGroups.loading
});

const mapStateToDispatch = dispatch => ({
    fetchConsumerGroups: bindActionCreators(fetchConsumerGroups, dispatch),
    deleteConsumerGroup: bindActionCreators(deleteConsumerGroup, dispatch),
    clearConsumerGroups: bindActionCreators(clearConsumerGroups, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ConsumerGroups);
